import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
export const typeMapObj = {
  INCREASE: '增员',
  REDUCE: '减员'
};
export const ADD = 'INCREASE';
export const REDUCE = 'REDUCE';
export const REPLACE = 'REPLACE';
//最小保费 低于这个限制报错
export const MINPREMIUM = 0.01;
export const translateReplace = ['证件号码', '已存在投保信息！', '证件类型输入值与此单元格数据不匹配', '身份证号有误', '工种为空', '导入人员不符合减员规则：姓名/证件号码未在该保单内', '主险方案不存在', '请输入有效证件号码', '证件号码已存在投保信息！', '保费金额不准确', '证件号码为空', '姓名为空', '证件类型为空', '证件号码为空', '生效日期为空', '保费为空', '在本保单内已存在退保信息，请勿重复添加！', '在本保单内已存在退保中信息，请勿重复添加！', '在本次批改内存在多条重复数据，请勿重复添加！', '在本保单内已存在投保信息，请勿重复添加！'];
const insurancePlanRelation = ['30+5%+1-3类', '30+5%+4类', '30+10%+1-3类', '30+10%+4类', '50+5%+1-3类', '50+5%+4类', '50+10%+1-3类', '50+10%+4类', '60+5%+1-3类', '60+5%+4类', '60+10%+1-3类', '60+10%+4类', '80+5%+1-3类', '80+5%+4类', '80+10%+1-3类', '80+10%+4类', '100+5%+1-3类', '100+5%+4类', '100+10%+1-3类', '100+10%+4类'];
export const translatePlan = function (planData) {
  let occupationTypeData = {};
  planData.forEach(item => {
    let splitIndex = item.name.lastIndexOf('+');
    let occupationType = item.name.slice(splitIndex + 1);
    occupationTypeData[item.mark] = occupationType;
  });
  return occupationTypeData;
};